import React from "react";
import { STRIPE_LINKS } from "../../config/siteConfig";
import { trackInitiateCheckout } from "../../lib/tracking";

const tiers = [
  {
    id: "tier-review",
    name: "Case Review",
    price: "$99",
    value: 99,
    note: "Analysis + Action Plan",
    href: STRIPE_LINKS.caseReview,
    highlight: false,
  },
  {
    id: "tier-package",
    name: "Appeal Package",
    price: "$399",
    value: 399,
    note: "Full Prep + Submission",
    href: STRIPE_LINKS.appealPackage,
    highlight: true,
  },
  {
    id: "tier-priority",
    name: "Priority Support",
    price: "$499",
    value: 499,
    note: "24hr Turnaround",
    href: STRIPE_LINKS.prioritySupport,
    highlight: false,
  },
];

export const PricingSection = () => (
  <section id="pricing" className="py-20 bg-slate-900/50">
    <div className="mx-auto max-w-7xl px-6">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold">
          Simple, Transparent
          <span className="text-blue-400"> Pricing</span>
        </h2>
        <p className="mt-4 text-slate-400 max-w-2xl mx-auto">
          One-time payments. No hidden fees. No monthly subscriptions.
        </p>
      </div>

      <div className="max-w-4xl mx-auto">
        <div className="grid md:grid-cols-3 gap-6">
          {tiers.map((tier) => (
            <div
              key={tier.id}
              className={
                tier.highlight
                  ? "rounded-2xl border-2 border-blue-500 bg-blue-500/10 p-6 text-center ring-1 ring-blue-500/50 transform md:-translate-y-2"
                  : "rounded-2xl border border-white/10 bg-white/5 p-6 text-center"
              }
            >
              {tier.highlight && (
                <span className="inline-block px-3 py-1 rounded-full bg-blue-500 text-white text-xs font-semibold mb-3">
                  Best Value
                </span>
              )}
              <h3 className="font-semibold text-lg mb-2">{tier.name}</h3>
              <p className={`text-3xl font-bold mb-1 ${tier.highlight ? "text-blue-400" : "text-white"}`}>
                {tier.price}
              </p>
              <p className="text-sm text-slate-500 mb-4">{tier.note}</p>
              <a
                href={tier.href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackInitiateCheckout({ tier: tier.name, priceUsd: tier.value })}
                className={`block w-full py-3 rounded-xl font-semibold transition ${
                  tier.highlight
                    ? "bg-blue-500 text-white hover:bg-blue-600"
                    : "bg-white/10 text-white hover:bg-white/20"
                }`}
                data-testid={`${tier.id}-cta`}
              >
                Get Started
              </a>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-sm text-slate-500">
          All prices in USD. No recurring charges. Secure payment via Stripe.
          Individual results vary and platform outcomes are not guaranteed.
        </p>
      </div>
    </div>
  </section>
);
